const CGU = () => {
  return (
    <>
      <span className="text-lg font-semibold">
        Conditions Générales d’Utilisation (CGU)
      </span>
      <br />
      Date de mise à jour : 8 septembre 2025
      <br />
      <br />
      <span className="text-lg font-semibold">Préambule</span>
      <br />
      Le Comité Interprofessionnel pour le Développement de la Formation dans le
      domaine des Marchandises Dangereuses (CIFMD), association française régie
      par la loi du 1er juillet 1901, à but non lucratif et non assujettie à la
      TVA, exploite le site internet{" "}
      <a
        className="text-blue-500"
        href="https://www.cifmd.org"
        target="_newPage"
      >
        www.cifmd.org
      </a>
      .
      <br />
      Ce site a pour objet principal l’inscription et la gestion en ligne des
      examens de Conseiller à la Sécurité pour le Transport des Marchandises
      Dangereuses (CSTMD), conformément aux dispositions de l’arrêté du 6
      février 2019 en vigueur.
      <br />
      Les présentes Conditions Générales d’Utilisation définissent le cadre
      contractuel applicable à l’accès au site, à la création et à l’utilisation
      d’un compte candidat, ainsi qu’aux conditions de participation aux examens
      organisés en ligne.
      <br />
      L’acceptation expresse et préalable de ces CGU est une condition
      indispensable pour finaliser l’inscription. Elle est recueillie via
      l’interface web d’inscription, qui impose leur lecture complète avant
      validation.
      <br />
      <br />
      <span className="text-lg font-semibold">
        Article 1 – Objet et cadre légal
      </span>
      <br />
      1. Les présentes CGU ont pour objet de régir :
      <ul className="list-disc ml-6">
        <li>
          Les modalités d’inscription aux examens, qu’ils soient initiaux ou de
          renouvellement ;
        </li>
        <li>La création et l’utilisation d’un compte personnel candidat ;</li>
        <li>
          Les conditions et modalités de déroulement des épreuves en ligne.
        </li>
      </ul>
      2. Le candidat s’engage à respecter, outre les présentes CGU :
      <ul className="list-disc ml-6">
        <li>
          La politique de confidentialité (RGPD) accessible sur{" "}
          <a
            className="text-blue-500"
            href="https://www.cifmd.org"
            target="_newPage"
          >
            www.cifmd.org
          </a>
          ;
        </li>
        <li>
          Les « Modalités de préparation, de connexion, de déroulement des
          épreuves et dispositifs de lutte contre la fraude », publiées sur le
          site{" "}
          <a
            className="text-blue-500"
            href="https://www.cifmd.org"
            target="_newPage"
          >
            www.cifmd.org
          </a>
          .
        </li>
      </ul>
      3. Le CIFMD se réserve le droit de modifier à tout moment les présentes
      CGU. La version applicable est celle en vigueur et acceptée par le
      candidat à la date de validation de son inscription.
      <br />
      <br />
      <span className="text-lg font-semibold">
        Article 2 – Accès et utilisation de la plateforme d’inscription
      </span>
      <br />
      1. L’inscription aux examens s’effectue exclusivement via la plateforme
      sécurisée d’inscription en ligne accessible depuis{" "}
      <a
        className="text-blue-500"
        href="https://www.cifmd.org"
        target="_newPage"
      >
        www.cifmd.org
      </a>
      .
      <br />
      2. Cette plateforme permet notamment :
      <ul className="list-disc ml-6">
        <li>
          La création d’un compte personnel candidat, protégé par un identifiant
          unique et un mot de passe confidentiel ;
        </li>
        <li>L’inscription à une session d’examen ;</li>
        <li>Le dépôt, le suivi et la validation des documents requis ;</li>
        <li>Le paiement en ligne ou via un délégataire désigné ;</li>
        <li>
          L’accès aux documents officiels (convocation, attestation de présence,
          relevé de notes, certificat électronique authentifié).
        </li>
      </ul>
      3. Des notifications électroniques sont adressées automatiquement au
      candidat à chaque étape de traitement de son dossier, jusqu’à la
      délivrance du certificat.
      <br />
      <br />
      <span className="text-lg font-semibold">
        Article 3 – Utilisation de la plateforme Managexam
      </span>
      <br />
      1. Pour la réalisation technique des examens en ligne, le CIFMD recourt au
      prestataire Managexam, éditeur d’une plateforme spécialisée dans
      l’organisation et la surveillance d’épreuves à distance.
      <br />
      2. L’utilisation de cette plateforme implique l’acceptation préalable par
      le candidat des conditions générales et politiques de confidentialité de
      Managexam.
      <br />
      3. Les services fournis incluent notamment :
      <ul className="list-disc ml-6">
        <li>La création du compte candidat sur l’application ;</li>
        <li>
          L’organisation et la réalisation du test préalable obligatoire ;
        </li>
        <li>L’accès sécurisé aux épreuves ;</li>
        <li>
          La surveillance en direct par un surveillant, comprenant
          l’enregistrement vidéo, la capture d’écran et le contrôle de
          l’environnement.
        </li>
      </ul>
      4. La plateforme Managexam n’intervient ni dans la correction des épreuves
      ni dans la transmission des résultats, ces opérations étant assurées
      exclusivement par le CIFMD.
      <br />
      5. Le candidat est seul responsable de la conformité de son équipement
      (matériel informatique, connexion internet, logiciels) et du maintien de
      son bon fonctionnement. Le CIFMD décline toute responsabilité en cas de
      dysfonctionnements liés à des causes externes ou indépendantes de sa
      volonté.
      <br />
      6. Toute réclamation relative au déroulement des épreuves ou aux résultats
      s’effectue conformément à la procédure décrite dans le document officiel «
      Modalités de préparation, de connexion, de déroulement des épreuves et
      dispositifs de lutte contre la fraude » disponible sur le site du CIFMD.
      <br />
      <br />
      <span className="text-lg font-semibold">
        Article 4 – Comptes utilisateur : candidat et délégataire
      </span>
      <br />
      1. Compte candidat
      <ul className="list-disc ml-6">
        <li>Strictement personnel, protégé par identifiant et mot de passe.</li>
        <li>
          Les informations fournies doivent être complètes, exactes et
          régulièrement mises à jour.
        </li>
        <li>
          Les modifications relatives aux nom et prénom ne peuvent être
          effectuées que par le CIFMD sur présentation de justificatifs
          officiels.
        </li>
      </ul>
      2. Compte délégataire
      <ul className="list-disc ml-6">
        <li>
          Réservé à l’employeur ou à tout tiers désigné par le candidat pour le
          paiement des frais d’inscription.
        </li>
        <li>
          Permet uniquement de procéder au paiement et de télécharger la
          convocation ainsi que l’attestation de présence.
        </li>
        <li>
          Ne donne pas accès aux autres données personnelles ou documents du
          candidat.
        </li>
        <li>Un seul compte délégataire est autorisé par entreprise.</li>
        <li>
          Le CIFMD ne saurait être tenu responsable des erreurs d’utilisation de
          ce service par le délégataire, le candidat demeurant seul responsable
          de son inscription et du suivi de son dossier.
        </li>
      </ul>
      <br />
      <span className="text-lg font-semibold">
        Article 5 – Conditions d’inscription et prérequis
      </span>
      <br />
      1. Prérequis à l’inscription définitive
      <ul className="list-disc ml-6">
        <li>
          L’inscription n’est considérée comme définitive qu’après réception et
          validation du paiement, des documents requis en matière de formation
          et de la validation du test préalable obligatoire (cf. points 3 et 4
          suivants).
        </li>
        <li>
          Toute préinscription non réglée dans les délais (date de clôture
          publiée sur le site et affichée dans l’espace candidat) est
          automatiquement annulée.
        </li>
      </ul>
      2. Modalités de paiement
      <ul className="list-disc ml-6">
        <li>
          Carte bancaire (moyen privilégié pour sa rapidité et sa sécurité) ;
        </li>
        <li>
          Virement bancaire (prise en compte après confirmation de réception) ;
        </li>
      </ul>
      3. Formation préalable
      <ul className="list-disc ml-6">
        <li>
          Le dépôt d’une ou plusieurs attestations de formation est obligatoire,
          adaptées au type d’examen, au périmètre du certificat et aux
          règlements TMD en vigueur à la date de l’épreuve.
        </li>
        <li>
          Les documents doivent être déposés au plus tard sept jours calendaires
          avant la date d’examen.
        </li>
        <li>
          Leur conformité est vérifiée par le CIFMD avant toute convocation.
        </li>
        <li>
          Si la formation est incomplète ou absente, l’inscription peut être
          reportée une seule fois à la session suivante, sur demande écrite.
        </li>
      </ul>
      4. Test préalable obligatoire
      <ul className="list-disc ml-6">
        <li>
          Réalisé via Managexam, après la date de clôture des inscriptions, aux
          dates communiquées par convocation.
        </li>
        <li>
          L’absence non justifiée entraîne l’annulation de l’inscription sans
          remboursement.
        </li>
        <li>
          En cas d’échec dû à des problèmes techniques avérés, un report unique
          et gracieux pourra être accordé.
        </li>
      </ul>
      <br />
      <span className="text-lg font-semibold">
        Article 6 – Déroulement de l’examen en ligne
      </span>
      <br />
      1. Sous réserve de validation de tous les prérequis, le candidat reçoit :
      <ul className="list-disc ml-6">
        <li>Une convocation initiale émise par le CIFMD ;</li>
        <li>
          La convocation finale précisant l’horaire exact, adressée par
          Managexam.
        </li>
      </ul>
      2. Le candidat est tenu de respecter l’intégralité des Clauses spécifiques
      du CIFMD, publiées sur le site{" "}
      <a
        className="text-blue-500"
        href="https://www.cifmd.org"
        target="_newPage"
      >
        www.cifmd.org
      </a>
      , et les règles de surveillance en vigueur.
      <br />
      3. Toute fraude, tentative de fraude ou comportement perturbateur pourra
      entraîner l’annulation immédiate de l’épreuve, sans remboursement, et un
      signalement aux autorités compétentes.
      <br />
      <br />
      <span className="text-lg font-semibold">
        Article 7 – Modification et report d’inscription
      </span>
      <br />
      1. Le changement de périmètre du certificat est possible jusqu’à la
      clôture des inscriptions de la session concernée.
      <br />
      2. Toute demande de changement de date d’examen doit être formulée par
      écrit et reste soumise à l’accord du CIFMD.
      <br />
      3. Après la clôture des inscriptions, aucune modification, quelle qu’en
      soit la nature, n’est recevable.
      <br />
      <br />
      <span className="text-lg font-semibold">Article 8 – Force majeure</span>
      <br />
      Du candidat
      <ul className="list-disc ml-6">
        <li>
          Constitue un cas de force majeure tout événement imprévisible,
          irrésistible et indépendant de la volonté du candidat (au sens de
          l’article 1218 du Code civil) rendant impossible sa participation à
          l’examen : hospitalisation, panne électrique majeure, intempéries
          exceptionnelles, sinistre, pandémie…
        </li>
        <li>
          Le candidat doit adresser une demande écrite de report au CIFMD dans
          un délai maximum de quinze jours calendaires suivant la date de
          l’examen, accompagnée des justificatifs nécessaires.
        </li>
        <li>
          Un report unique et gracieux pourra être accordé vers la session
          suivante.
        </li>
      </ul>
      Du CIFMD
      <ul className="list-disc ml-6">
        <li>
          Constitue un cas de force majeure pour le CIFMD tout événement
          extérieur, imprévisible et irrésistible empêchant l’organisation ou la
          réalisation d’une session d’examen, ou entraînant la perte, la
          corruption ou l’indisponibilité de données indispensables à la gestion
          des examens.
        </li>
        <li>
          Sont notamment visés : catastrophes naturelles, incendies, pandémies,
          décisions administratives, cyberattaques, pannes massives de réseau ou
          d’infrastructure, incidents techniques majeurs chez les prestataires
          essentiels (hébergeurs, opérateurs de télécommunications).
        </li>
        <li>
          En cas de survenance d’un tel événement, le CIFMD organise, dans les
          meilleurs délais, un report des candidats concernés vers une nouvelle
          session ou met en œuvre les mesures correctives nécessaires à la
          reprise des examens, sans frais supplémentaires ni indemnité pour les
          candidats.
        </li>
      </ul>
      <br />
      <span className="text-lg font-semibold">
        Article 9 – Propriété intellectuelle et protection du site
      </span>
      <br />
      Le site, son contenu et l’ensemble des services et documents mis à
      disposition par le CIFMD sont protégés par le droit de la propriété
      intellectuelle.
      <br />
      Toute reproduction, extraction, diffusion ou réutilisation non autorisée,
      totale ou partielle, est strictement interdite et expose son auteur à des
      poursuites civiles et pénales.
      <br />
      <br />
      <span className="text-lg font-semibold">
        Article 10 – Évolutions des services et contact
      </span>
      <br />
      1. Le CIFMD se réserve la faculté d’apporter à ses services toute
      modification, suspension ou suppression qu’il jugera utile, sans indemnité
      ni préavis, dans le respect de ses obligations légales.
      <br />
      2. Toute communication avec le CIFMD doit être effectuée exclusivement par
      écrit à l’adresse :{" "}
      <a className="text-blue-500" href="mailto:contact@cifmd.fr">
        contact@cifmd.fr
      </a>
      .
    </>
  );
};

export default CGU;
